module.exports = __webpack_public_path__ + "static/media/Ann_icon.bf6b4e0f.png";